import { createFileRoute } from '@tanstack/react-router';

import { useTranslations } from '~/i18n/use-translations.ts';
import { cn } from '~/utils/cn.ts';

export const Route = createFileRoute('/user/account')({
	component: UserAccountPage,
});

function UserAccountPage() {
	const t = useTranslations();
	return (
		<div className="flex h-full w-full px-2 py-4">
			<div className="flex flex-row">
				<p className="my-auto mr-2 flex text-foreground">{t('user.account.resetHint')}</p>
				<a
					className={cn(
						'flex cursor-pointer flex-row rounded-sm p-2',
						'text-foreground',
						'hover:underline focus:underline',
						'bg-card',
						'focus:bg-accent',
						'hover:bg-accent',
					)}
					href="/auth/reset-password"
				>
					{t('user.account.resetPassword')}
				</a>
			</div>
		</div>
	);
}
